
import { Component, Vue } from "vue-property-decorator";

@Component
export default class VTechnicalWork extends Vue {
  protected currentUser: IJWTUser | null = this.$store.state.currentUser;
  protected watchers: Function[] = [];

  protected created() {
    this.watchers.push(
      this.$store.watch(
        state => state.currentUser,
        currentUser => {
          this.currentUser = currentUser;

          this.redirectRoot(currentUser.is_lock);
        }
      )
    );

    this.redirectRoot(this.$store.state.currentUser.is_lock);
  }

  protected redirectRoot(is_lock: boolean) {
    if (!is_lock) {
      this.$router.push({ name: "root" });
    }
  }

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }
}
